import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorMotherBoardsFromFactor,
  fetchProcessorMotherBoardsFromFactorAttributes,
  fetchProcessorMotherBoardsFromFactorById,
  updateProcessorMotherBoardsFromFactor,
  updateStatusInProcessorMotherBoardsFromFactor,
} from "./thunk";

interface CategoryState {
  processor_motherboards_from_factor_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_motherboards_from_factor_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_motherboards_from_factor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorMotherBoardsFromFactorAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMotherBoardsFromFactorAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_motherboards_from_factor_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorMotherBoardsFromFactorAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchProcessorMotherBoardsFromFactorById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMotherBoardsFromFactorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorMotherBoardsFromFactorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorMotherBoardsFromFactor.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_motherboards_from_factor_list = state.processor_motherboards_from_factor_list.map((processor_motherboards_from_factor) =>
          processor_motherboards_from_factor.id === action.payload.id ? action.payload : processor_motherboards_from_factor
        );
      })
      .addCase(addProcessorMotherBoardsFromFactor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Processor MotherBoards Chips";
      })
      .addCase(updateProcessorMotherBoardsFromFactor.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_motherboards_from_factor_list = state.processor_motherboards_from_factor_list.map((processor_motherboards_from_factor) =>
          processor_motherboards_from_factor.id === action.payload.id ? action.payload : processor_motherboards_from_factor
        );
      })
      .addCase(updateStatusInProcessorMotherBoardsFromFactor.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorMotherBoardsFromFactor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
